<template>
    <div class="box-second">
        <p class="title-crumb" style="justify-content: space-between;padding-right:1vw;">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>绿色施工</el-breadcrumb-item>
                <el-breadcrumb-item>升降机监测</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button type="warning" size="mini" @click="config()">参数配置</el-button>
        </p>
        <div class="main">
            <div class="main-left">
                <div class="main-left-item" v-for="(item,index) in towerlist" :key="index" :class="{'curTower':towerId==item.id}" @click="changeTower(item)">
                    <p class="name nowrap">{{item.name}}</p>
                    <p class="state" :class="{'color8':item.statusStr=='离线','color10':item.statusStr!='离线'}">{{item.statusStr}}</p>
                    <p class="num nowrap">编号：{{item.deviceId}}</p>
                </div>
            </div>
            <div class="main-right">
                <div class="main-right-first">
                    <div class="real-data ele-real">
                        <p style="text-align: left;padding-left:1vh;font-size:1vw;height:3vh;width:100%;">实时监控</p>
                        <div class="real-data-l">
                            <p class="real-data-l-item" style="justify-content: space-around;">
                                <span style="width:auto;">额定载重：{{ allPart.weightReay }}kg</span>
                                <span style="width:auto;">额定高度：{{ allPart.height }}m</span>
                                <!-- <el-progress :text-inside="true" :stroke-width="18" :percentage="100" style="width:50%;" :show-text="false"></el-progress> -->
                                <!-- <span class="abr">{{ allPart.weightReay }}kg</span> -->
                            </p>
                            <!-- <p class="real-data-l-item">
                                <span style="">额定高度：{{ allPart.height }}m</span>
                            </p> -->
                            <p class="real-data-l-item" style="justify-content: center;">
                                <span style="width:auto;">实时速度：{{ allPart.speed }}m/s</span>
                            </p>
                            <div class="real-data-l-item" style="height:18vh;align-items: flex-start;justify-content: center;">
                                <!-- <span style="position: relative;top: 4vh;"></span> -->
                                <div v-if="allPart.speedStatus=='1'" style="width:50%;height:100%;position: relative;padding-top:2vh;">
                                    <img src="../../assets/image/up-gif.gif" style="height:12vh;position: relative;" />
                                    <!-- <p style="width:100%;text-align: center;">上</p> -->
                                </div>
                                <div v-else-if="allPart.speedStatus=='2'" style="width:50%;height:100%;position: relative;padding-top:2vh;">
                                    <img src="../../assets/image/down-gif.gif" style="height:12vh;position: relative;" />
                                    <!-- <p style="width:100%;text-align: center;">下</p> -->
                                </div>
                                <div v-else style="width:50%;height:100%;position: relative;padding-top:2vh;">
                                    <img src="../../assets/image/ele-stop.png" style="height:12vh;position: relative;" />
                                    <!-- <p style="width:100%;text-align: center;">停止</p> -->
                                </div>
                                <!-- <img src="" /> -->
                            </div>
                        </div>
                        <div class="real-data-r" style="width:50%;height:calc( 100% - 3vh );">
                            <p class="real-data-l-item">
                                <span>重量</span>
                                <el-progress :text-inside="true" :stroke-width="18" :percentage="parseFloat(allPart.weightPercent||0)" style="width:50%;" :show-text="false"></el-progress>
                                <span class="abr">{{ allPart.weight }}吨</span>
                            </p>
                            <p class="real-data-l-item">
                                <span>重量百分比</span>
                                <el-progress :text-inside="true" :stroke-width="18" :percentage="parseFloat(allPart.weightPercent||0)" style="width:50%;" :show-text="false"></el-progress>
                                <span class="abr">{{ allPart.weightPercent }}%</span>
                            </p>
                            <p class="real-data-l-item">
                                <span>实时高度</span>
                                <el-progress :text-inside="true" :stroke-width="18" :percentage="parseFloat(allPart.heightPercent||0)" style="width:50%;" :show-text="false"></el-progress>
                                <span class="abr">{{ allPart.height }}米</span>
                            </p>
                            <p class="real-data-l-item">
                                <span>高度百分比</span>
                                <el-progress :text-inside="true" :stroke-width="18" :percentage="parseFloat(allPart.heightPercent||0)" style="width:50%;" :show-text="false"></el-progress>
                                <span class="abr">{{allPart.heightPercent}}%</span>
                            </p>
                            <!-- <p class="real-data-l-item">
                                <span style="">速度</span>
                                <el-progress :text-inside="true" :stroke-width="18" :percentage="70" style="width:50%;" :show-text="false"></el-progress>
                                <span class="abr">{{ allPart.speed }}米每秒</span>
                            </p>
                            <p class="real-data-l-item">
                                <span style="">实时倾斜度</span>
                                <el-progress :text-inside="true" :stroke-width="18" :percentage="parseFloat(allPart.tiltPercent||0)" style="width:50%;" :show-text="false"></el-progress>
                                <span class="abr">{{ allPart.tilt }}度</span>
                            </p>
                            <p class="real-data-l-item">
                                <span style="">倾斜百分比</span>
                                <el-progress :text-inside="true" :stroke-width="18" :percentage="parseFloat(allPart.tiltPercent||0)" style="width:50%;" :show-text="false"></el-progress>
                                <span class="abr">{{allPart.tiltPercent}}百分比</span>
                            </p> -->
                        </div>
                    </div>
                </div>
                <!--  -->
                <div class="main-right-first" style="margin-top:1vh;height:20vh;">
                    <p style="text-align: left;padding-left:1vh;font-size:1vw;height:3vh;width:100%;">设备状态</p>
                    <div class="main-dure">
                        <p>
                            <span>高度</span>
                            <span v-if="eleState.systemStatusForelockStatus=='1'" class="color6">预警</span>
                            <span v-else-if="eleState.systemStatusForelockStatus=='2'" style="color:red;">报警</span>
                            <span v-else class="color10">正常</span>
                            <span>预警次数 <span class="color6">{{towerH.heightWarnCount}}</span></span>
                        </p>
                        <p>
                            <span>速度</span>
                            <span v-if="eleState.systemStatusBehindlockStatus=='1'" class="color6">预警</span>
                            <span v-else-if="eleState.systemStatusBehindlockStatus=='2'" style="color:red;">报警</span>
                            <span v-else class="color10">正常</span>
                            <span>预警次数 <span class="color6">{{towerH.speedWarnCount}}</span></span>
                        </p>
                        <!-- <p>
                            <span>高度</span>
                            <span v-if="eleState.systemStatusHeight=='1'" class="color6">预警</span>
                            <span v-else-if="eleState.systemStatusHeight=='2'" style="color:red;">报警</span>
                            <span v-else class="color10">正常</span>
                            <span>预警次数<span class="color6">{{towerH.gdyj}}</span></span>
                        </p> -->
                    </div>
                    <div class="main-dure">
                        <p>
                            <span>姿态状态</span>
                            <span v-if="eleState.systemStatusTilt=='1'" class="color6">预警</span>
                            <span v-else-if="eleState.systemStatusTilt=='2'" style="color:red;">报警</span>
                            <span v-else class="color10">正常</span>
                            <span>预警次数 <span class="color6">{{towerH.tiltWarnCount}}</span></span>
                        </p>
                        <p>
                            <span>重量状态</span>
                            <span v-if="eleState.systemStatusWeight=='1'" class="color6">预警</span>
                            <span v-else-if="eleState.systemStatusWeight=='2'" style="color:red;">报警</span>
                            <span v-else class="color10">正常</span>
                            <span>预警次数 <span class="color6">{{towerH.weightWarnCount}}</span></span>
                        </p>
                        <!-- <p>
                            <span>门锁</span>
                            <span>前门</span>
                            <span v-if="eleState.systemStatusForelockStatus=='1'" class="color6">预警</span>
                            <span v-else-if="eleState.systemStatusForelockStatus=='2'" style="color:red;">报警</span>
                            <span v-else class="color10">正常</span>
                            <span>预警次数<span class="color6">{{towerH.msqm}}</span></span>
                        </p>
                        <p>
                            <span></span>
                            <span>后门</span>
                            <span v-if="eleState.systemStatusBehindlockStatus=='1'" class="color6">预警</span>
                            <span v-else-if="eleState.systemStatusBehindlockStatus=='2'" style="color:red;">报警</span>
                            <span v-else class="color10">正常</span>
                            <span>预警次数<span class="color6">{{towerH.mshm}}</span></span>
                        </p> -->
                        <el-button @click="deatilWarn" v-if="towerId&& towerId!=''" type="primary" style="position: absolute;top: 15px;right: 15px;"> 历史监测</el-button>

                    </div>
                </div>
                <!-- 特种设备操作人员列表 -->
                <div class="main-right-first" style="margin-top:1vh;height:auto;padding:1vh;min-height: 23.7vh;">
                    <p style="text-align: left;padding-left:1vh;font-size:1vw;height:3vh;width:100%;display:flex;justify-content: space-between;align-items: center;">
                        <span>特种设备操作人员列表</span>
                        <el-date-picker
                          v-model="tableTime"
                          value-format="yyyy-MM-dd"
                          type="date"
                          @change="doFilter"
                          placeholder="选择日期">
                        </el-date-picker>
                    </p>
                    <div class="special-table">
                        <el-table
                            :data="tableData"
                            style="width: 100%">
                            <el-table-column
                                prop="index"
                                label="序号">
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="姓名">
                            </el-table-column>
                            <el-table-column
                                prop="certificateNumber"
                                label="证件编号">
                            </el-table-column>
                            <el-table-column
                                prop="certificatePhoto"
                                label="查看证书">
                                <template slot-scope="scope">
                                    <el-image
                                        v-if="scope.row.certificatePhoto!=''"
                                        style="width: 60px; height: 60px"
                                        :src="scope.row.certificatePhoto"
                                        :preview-src-list="scope.row.photoList"
                                    ></el-image>
                                    <div v-else class="no-photo" style="display: inline-block;">
                                        <span style="display: block;">暂无</span>
                                        <span style="display: block;">图片</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作记录" width="400">
                                <template slot-scope="scope">
                                    <div style="height:100px;display: flex;align-content: center;align-items: center;justify-content: center;">
                                        <el-image
                                            v-if="scope.row.photoFile!=''"
                                            style="width: 6vh; height: 6vh;"
                                            :src="scope.row.photoFile"
                                            :preview-src-list="scope.row.photoList"
                                        ></el-image>
                                        <span style="margin-left:1vh;">时间：{{scope.row.clockTime}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <!-- 维护标准窗口 -->
        <el-dialog
            title="参数配置"
            :visible.sync="editFormVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            custom-class='tower-dig'
            class="add-form"
            width="60%"
        >
          <div class="config-con">
            <p class="config-con-item" v-for="(item,index) in configList" :key="index">
              <span style="display: inline-block;width: 6vw;">{{item.name}}</span>
              <span style="display: inline-block;width: 10vw;">单位：（{{item.unit}}）</span>
              <span style="display: inline-block;width: 20vw;">设备报警限位：<el-input v-model="item.val" placeholder="请输入" style="width:5vw;"></el-input> {{item.unit}}</span>
              <!-- <span>默认使用系统设置</span>
              <el-switch
                v-model="item.status"
                inactive-text="关闭">
              </el-switch> -->
            </p>
          </div>
          <div slot="footer" class="dialog-footer" >
              <el-button @click="editFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitEditRow" :disabled="disabled">确 定</el-button>
              <el-button type="info" @click="setDetfaule">恢复默认值</el-button>
          </div>
        </el-dialog>
    </div>
</template>
<script>
import HighCharts from 'highcharts'
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
    data(){
        return{
            groupId:'',
            towerId:'',//当前塔吊id
            deviceId:'',//当前塔吊deviceId
            towerlist:[],//塔吊设备列表
            allPart:{},//当前塔吊信息
            towerH:{},//24小时数据
            tableData:[],//特种人员列表
            eleState:{},//项目预计状态
            timeRefrsh:null,
            tableTime:util.myTime.getCurTime(),

            editFormVisible: false,
            configList:[
                {name:'重量',unit:'吨',val:'',status:true,default:'3'},
                // {name:'重量百分比',unit:'百分比',val:'',status:true},
                // {name:'人数',unit:'个',val:'',status:true,default:'12'},
                {name:'高度',unit:'米',val:'',status:true,default:'200'},
                // {name:'高度百分比',unit:'百分比',val:'',status:true},
                {name:'速度',unit:'米每秒',val:'',status:true,default:'3'},
                {name:'倾斜度',unit:'度',val:'',status:true,default:'10'},
                // {name:'倾斜百分比',unit:'百分比',val:'',status:true},
            ],
            configData:{
                projectId:'',
                customEarlyWarningWeight:'',//自定义重量预警
                customEarlyWarningHeight:'',//自定义高度预警
                customEarlyWarningSpeed:'',//自定义速度预警
                // customEarlyWarningPersonNum:'',//自定义人数预警
                customEarlyWarningTilt:'',//自定义倾斜预警
            },
            hasConf:false,//判断是否已经有配置
            disabled:false,
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getEleList()
        //this.setChart1()
    },
    destroyed: function() {
        if(this.timeRefrsh){
            window.clearTimeout(this.timeRefrsh)
        }
    },
    methods:{
        //获取塔吊设备
        getEleList(){
            var that = this
            myHttp.getEleListByPage({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.elevatorList||[]
                    that.towerlist = list
                    if(list.length>0 && that.towerId==''){
                        that.towerId = list[0].id
                        that.deviceId = list[0].deviceId
                    }
                    if(that.towerId!=''){
                        that.getRealInfo()
                        that.getHour()
                        that.getPerson()
                    }
                }
            })
        },
        getRealInfo(){
            var that = this
            myHttp.getEleInfoById({
                id:this.towerId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.elevator||{}
                    data.weightReay = data.weight && data.weightPercent?(parseFloat(data.weight)/parseFloat(data.weightPercent)*100).toFixed(2):''
                    that.allPart = data
                }
                that.timeRefrsh = setTimeout(function(){
                    that.getRealInfo()
                },60000)
            })
        },
        //获取24小时监测数据
        getHour(){
            var that = this
            // myHttp.elevatorWarning({
            //     projectId:this.groupId,
            //     deviceId:this.deviceId
            // }).then(function(resp){
            //     if(resp.data.code=='200'){
            //         var data = resp.data.data
            //         that.towerH = data
            //         that.eleState = data.ElevatorLog||{}
            //     }
            // })
            myHttp.elevatorEquipStatusToday({
                projectId:this.groupId,
                deviceId:this.deviceId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    that.towerH = data
                }
            })
        },
        //24小时监测时长
        // setChart1(obj){
        //     var data = {
        //         zhengChang:obj.zhengChang||0,
        //         baoJing:obj.baoJing||0,
        //         yuJing:obj.yuJing||0,
        //     }
        //     data.zhengChang = data.zhengChang==0?0.001:data.zhengChang
        //     data.baoJing = data.baoJing==0?0.001:data.baoJing
        //     data.yuJing = data.yuJing==0?0.001:data.yuJing
        //     var chart = HighCharts.chart('realDura', {
        //         subtitle:{
        //             floating:true,
        //             verticalAlign:'middle',
        //             text:'',
        //             style: {
        //                 fontSize: 10,
        //                 color: '#7058F8',
        //             },
        //             y:30,
        //         },
        //         title: {
        //             // floating:true,
        //             text: '24小时监测时长',
        //             align:'center',
        //             verticalAlign:'middle',
        //             style: {
        //                 fontSize:'10px'
        //             },
        //             y:0,
        //         },
        //         tooltip: {
        //             pointFormat: '<b>{point.y:.0f}</b>',
        //             headerFormat:'<span style="font-size: 16px">{series.name}</span><br/><span style="font-size: 16px">{point.key}</span>：'
        //         },
        //         colors:['#038BF9','#FD9142', '#FCD537'],
                
        //         plotOptions: {
        //             pie: {
        //                 allowPointSelect: true,
        //                 cursor: 'pointer',
        //                 dataLabels: {
        //                     enabled: true,
        //                     // formatter:function(){
                                
        //                     //     return this.y==0.001?'0%':this.percentage+' %'
        //                     // },
        //                     // format: ' {point.percentage:.1f} %',
        //                     format:'',
        //                     style:{
        //                         fontSize:'10px'
        //                     },
        //                 },
        //                 showInLegend: true,
        //                 point: {
        //                     events: {}
        //                 },
        //             }
        //         },
        //         series: [{
        //             type: 'pie',
        //             size:'90%',
        //             innerSize: '70%',
        //             name: '监测时长',
        //             dataLabels:{
        //                 formatter: function () {
        //                     return this.point.name;
        //                 },
        //                 //color: '#ffffff',
        //                 distance: 0,

        //             },
        //             data: [
        //                 ['正常', data.zhengChang],
        //                 ['报警', data.baoJing],
        //                 ['预警',data.yuJing]
        //             ]
        //         }]
        //     });
        // },

        //获取人员
        getPerson(){
            var that = this
            myHttp.getTzListByTeamsId({
                projectId:this.groupId,
                teamsId:this.getTeamId(this.deviceId),
                daysss:this.tableTime,
                status:'2',
                attendanceSn:this.getSn(this.deviceId)
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.attendList||[]
                    for(var i=0;i<list.length;i++){
                        list[i].certificatePhoto = list[i].certificatePhoto && list[i].certificatePhoto!=''?base.httpCtx+list[i].certificatePhoto:''
                        list[i].photoList = []
                        if(list[i].certificatePhoto!=''){
                            list[i].photoList.push(list[i].certificatePhoto)
                        }
                        list[i].photoFile = list[i].photoFile && ''!=list[i].photoFile?base.httpCtx+list[i].photoFile:''
                        if(list[i].photoFile!=''){
                            list[i].photoList.push(list[i].photoFile)
                        }
                        list[i].index = (i+1)
                    }
                    that.tableData = list
                }
            })
        },
        //获取班组id
        getTeamId(id){
            var list = this.towerlist
            var result = ''
            for(var i=0;i<list.length;i++){
                if(id==list[i].deviceId){
                    result = list[i].teamsId
                }
            }
            return result
        },
        //获取sn
        getSn(id){
            var list = this.towerlist
            var result = ''
            for(var i=0;i<list.length;i++){
                if(id==list[i].deviceId){
                    result = list[i].attendanceSn
                }
            }
            return result
        },

        //选择塔吊
        changeTower(obj){
            this.towerId = obj.id
            this.deviceId = obj.deviceId
            window.clearTimeout(this.timeRefrsh)
            this.getRealInfo()
            this.getHour()
            this.getPerson()
        },
        //
        doFilter(){
            this.getPerson()
        },

        //跳转查看信息
        attendInfo(row){
            this.$router.push({ name: 'specialPerson',params:{id:this.towerId,personId:row.personId,status:'2'} })
        },
         // 跳转预警监测页面
        deatilWarn(){
            var id = this.deviceId
            this.$router.push({path:'/eleWarn/'+id})
        },

        //数据转列表
        setConfigList(data){
            for(var i=0;i<this.configList.length;i++){
                if(i==0){
                    this.configList[i].val = data.customEarlyWarningWeight
                // }else if(i==1){
                //     this.configList[i].val = data.customEarlyWarningPersonNum
                }else if(i==1){
                    this.configList[i].val = data.customEarlyWarningHeight
                }else if(i==2){
                    this.configList[i].val = data.customEarlyWarningSpeed
                }else if(i==3){
                    this.configList[i].val = data.customEarlyWarningTilt
                }
            }
        },

        //配置
        config(){
            this.dialogTitle = '参数配置'
            this.editFormVisible = true
            this.configData.projectId = util.session.get('groupId')
            // this.configData.projectName = this.projectName
            var that = this
            myHttp.findEquipElevatorConfig({
                projectId:util.session.get('groupId')
            }).then(function(resp){
                if(resp.data.code=='200'){
                var data = resp.data.data
                if(data){
                    that.hasConf = true
                    that.configData = data
                    that.setConfigList(data)
                }else{
                    that.hasConf = false
                }
                }else{
                that.$message.error(resp.data.msg)
                }
            })
        },

        // 维护环境标准configData
        sumbitEditRow(formName) {
            var that = this
            this.disabled = true
            for(var i=0;i<this.configList.length;i++){
                if(i==0){
                    this.configData.customEarlyWarningWeight = this.configList[i].val
                // }else if(i==1){
                //     this.configData.customEarlyWarningPersonNum = this.configList[i].val
                }else if(i==1){
                    this.configData.customEarlyWarningHeight = this.configList[i].val
                }else if(i==2){
                    this.configData.customEarlyWarningSpeed = this.configList[i].val
                }else if(i==3){
                    this.configData.customEarlyWarningTilt = this.configList[i].val
                }
            }
            
            delete this.configData.createDate
            delete this.configData.updateDate
            this.configData.createBy = util.session.get('user').id
            myHttp.setUpEquipElevatorConfig(this.configData).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('配置成功')
                    that.editFormVisible = false
                    that.disabled = false
                }else{
                    that.$message.error(resp.data.msg)
                    that.disabled = false
                }
            },function(){that.disabled = false})
            // if(this.hasConf){
            //     this.configData.updateBy = util.session.get('user').id
            //     myHttp.updateElevatorCopy(this.configData).then(function(resp){
            //     if(resp.data.code=='200'){
            //         that.$message.success('配置成功')
            //         that.editFormVisible = false
            //     }else{
            //         that.$message.error(resp.data.msg)
            //     }
            //     })
            // }else{
            //     this.configData.createBy = util.session.get('user').id
            //     myHttp.addElevatorCopy(this.configData).then(function(resp){
            //     if(resp.data.code=='200'){
            //         that.$message.success('配置成功')
            //         that.editFormVisible = false
            //     }else{
            //         that.$message.error(resp.data.msg)
            //     }
            //     })
            // }
        },

        //恢复默认值
        setDetfaule(){
            for(var i=0;i<this.configList.length;i++){
                this.configList[i].val = this.configList[i].default
            }
        },
    }
}
</script>
<style scoped>
    @import '../../assets/css/clock.css';
    .main-left{
        width: 10vw;
        height: 100%;
        position: relative;
        padding: 1vh 0.6vh;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        background: #fff;
        align-content: flex-start;
    }
    .main-left-item{
        height: 7vh;
        width: 100%;
        position: relative;
        background: #E7F1FB;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        padding: 0.5vh;
        cursor: pointer;
        margin-top: 1vh;
    }
    .main-left-item p{
        height: 3vh;
        position: relative;
        text-align: left;
        display: flex;
        align-content: center;
        align-items: center;
    }
    .main-left-item .name{
        width: calc( 100% - 3vw );
        position: relative;
    }
    .main-left-item .state{
        width: 3vw;
        position: relative;
        justify-content: flex-end;
    }
    .main-left-item .num{
        width: 100%;
        position: relative;
    }
    .curTower{
        background: #1E369A;
    }
    .curTower .name,.curTower .state,.curTower .num{
        color: #fff;
    }

    .main-right{
        width: calc( 100% - 10vw );
        height: 100%;
        position: relative;
        padding: 0 1vh;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow:auto;
    }
    .main-right-first{
        width: 100%;
        height: 40vh;
        position: relative;
        border-radius: 6px;
        background: #fff;
        display: flex;
        flex-wrap: wrap;
    }
    .real-data{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh;
        display: flex;
        flex-wrap: wrap;
    }
    .real-data-l,.real-data-r{
        width:50%;
        height:calc( 100% - 3vh );
        padding:2vh 5vh;
    }
    .real-data-l-item{
        width:100%;
        display:flex;
        height:6vh;
        align-items: flex-end;
        margin-bottom: 1vh;
    }
    .real-data-l-item span{
        display: inline-block;
        width: 8vw;
        text-align: left;
    }
    .real-data-l-item .abr{
        position: absolute;
        bottom: 2vh;
        left: 40%;
        width: 3.5vw;
        height: 3vh;
        /* line-height: 25px; */
        font-size: 0.8vw;
        text-align: center;
        color: #707070;
        background: #c5c1c1;
        background: url(../../assets/image/box.png) no-repeat;
        background-size: 100% 100%;
    }
    .real-clock{
        width: 33%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    #wrap.real-clock-con{
        /* width:100%;
        height:calc( 100% - 3vh ); */
        /* padding:2vh 0; */
        margin-top: 3vh;
        width: 202px;
        height: 202px;
    }
    .main-dure{
        width:50%;
        height:100%;
        position: relative;
        padding-left:2vw;
        display:flex;
        flex-wrap:wrap;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
    .main-dure p{
        width: 100%;
        position: relative;
        height:4vh;
        display:flex;
     }
     .main-dure p span{
         width: 20%;
         position: relative;
     }
     .special-table{
         width: 100%;
         height: calc( 100% - 3vh );
         position: relative;
         padding: 1vh;
     }
     .no-photo{
         width:6vh;
         height:6vh;
         display: flex;
         justify-content: center;
         justify-items: center;
         align-content: center;
         background: #F5F7FA;
         flex-wrap: wrap;
         color:#C0C4CC;
     }
</style>
<style>
    .real-data .el-progress-bar__outer{
        background: #69BCFF;
    }
    .ele-real .el-progress-bar__inner{
        background-color: #038BF9;
    }
 @import '../../assets/css/common.css';
 .tower-dig .el-dialog__title{
      color: #0085FF;
    }
    .tower-dig .el-dialog__body,.tower-dig .el-dialog__footer{
      border-top: 1px solid #ddd;
    }
    .tower-dig span{
      font-weight: bold;
    }
    .tower-dig .el-dialog__header{
      text-align: left;
    }
    .config-con{
      display:flex;
      flex-wrap:wrap;
      width:100%;
      height:auto;
    }
    .config-con-item{
      width:100%;
      padding:1vh 0;
      display:flex;
      justify-content: space-around;
      align-items: center;
      align-content: center;
    }
</style>